var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#146EB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.161 20.762c1.016-1.016 2.662-1.016 3.677 0 .938.937 1.01 2.412.217 3.431l-.217.245-17.875 17.875c-.937.938-2.412 1.01-3.432.217l-.245-.217-8.125-8.125c-1.015-1.015-1.015-2.661 0-3.677.938-.937 2.412-1.009 3.432-.216l.245.216 6.287 6.285L43.16 20.762z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBlue);
export default __webpack_public_path__ + "static/media/success-blue.ce42194c050af22abd90d39e6387e895.svg";
export { ForwardRef as ReactComponent };